<template>
  <div class="event-projects">
    <modal :title="title" :subtitle="''"
      v-on:close="switchModal"
      v-if="modal">
      <project v-on:close="switchModal"/>
    </modal>
    <div class="projects-actions">
      <nav-bar :dataFunction="getEventProjects" :orderFields="orderFields"/>
      <button v-if="permissionsStatus.isProjectCreateAllowed"
        class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Добавить проект
      </button>
    </div>
    <div v-for="project in projects" :key="project.id"
      class="project"
      :class="{ 'project--editable': permissionsStatus.isProjectUpdateAllowed ||
                                     permissionsStatus.isProjectDeleteAllowed }"
      @click="goToProjectPage(project)">
      <div class="project-progress" :style="{ 'clip-path': `polygon(0 0, ${project.completeness * 100}% 0, ${project.completeness * 100}% 100%, 0 100%)` }">
        <div class="project-info">
          <div class="project-title">
            {{ project.name }}
          </div>
          <div class="project-date">
            {{ getDisplayText(project.created_at) }}
          </div>
        </div>
        <div class="project-responsibles">
          <div class="project-title">
            Ответственные
          </div>
          <div class="responsibles" v-if="!!project.responsible">
            <div class="ccs-tag ccs-tag--normal" v-for="(item, index) in project.responsible.data" :key="index">
              {{ item.full_name }}
            </div>
          </div>
          <div v-else>
            Не назначены
          </div>
        </div>
        <div class="project-responsible_fnd">
          <div class="project-title">
            Ответственный ФНД
          </div>
          {{ !!project.fnd ? project.fnd.code : 'Не назначено' }}
        </div>
      </div>
      <div class="project-info">
        <div class="project-title">
          {{ project.name }}
        </div>
        <div class="project-date">
          {{ getDisplayText(project.created_at) }}
        </div>
      </div>
      <div class="project-responsibles">
        <div class="project-title">
          Ответственные
        </div>
        <div class="responsibles" v-if="!!project.responsible">
          <div class="ccs-tag ccs-tag--normal" v-for="(item, index) in project.responsible.data" :key="index">
            {{ item.full_name }}
          </div>
        </div>
        <div v-else>
          Не назначены
        </div>
      </div>
      <div class="project-responsible_fnd">
        <div class="project-title">
          Ответственный ФНД
        </div>
        {{ !!project.fnd ? project.fnd.code : 'Не назначено' }}
      </div>
    </div>
    <pagination :dataFunction="getEventProjects"/>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import Modal from '@/components/Modal.vue';
import Project from '@/components/modals/projects/Project.vue';
import NavBar from '@/components/NavBar.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'EventProjects',
  components: {
    Modal,
    Project,
    NavBar,
    Pagination,
  },
  data() {
    return {
      orderFields: [{
        prop: 'name',
        text: 'Названию',
      }, {
        prop: 'created_at',
        text: 'Дате создания',
      }],
      modal: false,
      editableProject: null,
      title: 'Новый проект',
      dateFormatOptions: {
        day: 'numeric',
        year: 'numeric',
        month: 'numeric',
      },
    };
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapState('projects', ['projects']),
    ...mapGetters('session', ['permissionsStatus']),
  },
  methods: {
    ...mapActions('projects', ['getEventProjects']),
    switchModal() {
      this.modal = !this.modal;
    },
    getDisplayText(data) {
      let date = new Date(data);
      return date.toLocaleString('ru-RU', this.dateFormatOptions);
    },
    goToProjectPage(project) {
      this.$router.push({ name: 'project', params: { projectID: project.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.event-projects {
  min-height: 100%;
  min-width: 100%;

  .projects-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .project {
    position: relative;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 20px;
    min-height: 100px;
    width: 100%;
    display: flex;
    align-items: stretch;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(129, 129, 129, 0.2);
    cursor: pointer;

    > div:not(:last-child) {
      margin-right: 30px;
    }

    &-responsibles {
      max-width: 305px;
      width: 305px;

      .responsibles {
        max-width: 305px;
        width: 305px;
        display: flex;
        flex-wrap: wrap;

        > div {
          margin: 0 5px 5px 0;
        }

      }

    }

    &-progress {
      position: absolute;
      box-sizing: border-box;
      top: 0;
      left: 0;
      padding: 20px;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: stretch;
      background: $primary;
      border-radius: 5px;

      > div:not(:last-child) {
        margin-right: 30px;
      }

      .project-info {

        .project-title, .project-date {
          color: #fff;
        }

      }

      .project-title, .project-description, .project-responsibles, .project-responsible_fnd {
        color: #fff;
      }

    }

    &-title {
      margin-bottom: 10px;
      color: #000;
      font-size: 12px;
      font-weight: bold;
    }

    &-point {
      margin-bottom: 5px;
      color: $primary;
      font-size: 20px;
      font-weight: bold;
    }

    &-date {
      font-size: 12px;
    }

    &-tansport {
      color: $primaryLighter;
      font-size: 14px;
      font-weight: bold;
    }

    &-description {
      max-width: 25%;
      font-size: 14px;
    }

    &-info {
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      .project-title {
        color: $primary;
        font-size: 16px;
      }

      .project-date {
        font-size: 16px;
      }

    }

  }

}
</style>
